<template>
	<div class="container">
		
		<div class="wrapper">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/store' }">软件商店</el-breadcrumb-item>
			  <el-breadcrumb-item :to="{name:'soft-list',params:{parentId:softType.parentId,typeId:softType.parentId}}">{{softType.parentName}}</el-breadcrumb-item>
			  <el-breadcrumb-item v-if="softType.typeId" :to="{name:'soft-list',params:{parentId:softType.parentId,typeId:softType.typeId}}">{{softType.typeName}}</el-breadcrumb-item>
			  <el-breadcrumb-item>{{data.name}}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="soft-msg">
				<div class="logo">
					<el-image :src="data.logo" fit="scale-down"></el-image>
				</div>
				<div>
					<div class="name">{{data.name}}</div>
					<div class="rate"><el-rate v-model="value" disabled show-score text-color="#ff9900" score-template="{value}"></el-rate></div>
					<div class="desc">
						<span v-if="data.adaptedIndustries">适合行业：{{data.adaptedIndustries}}</span>
						<span v-if="data.userVolume">规模：{{data.userVolume}}人</span>
					</div>
				</div>
				<div class="btn">
					<span class="guanzhu-btn" @click="data.isCollect?cancleSoftCollect():collect()"><i class="iconfont" :class="data.isCollect?'icon-31guanzhu1xuanzhong':'icon-31guanzhu1'"></i>{{data.isCollect?'取消收藏':'收藏'}}</span>
					<el-button type="warning" size="mini" round>咨询产品</el-button>
				</div>
			</div>
			<div>
				<div class="soft-wrapper">
					<router-view :data="data"></router-view>
				</div>
				<!-- 右侧侧边栏 -->
				<div class="sidebar">
					<div class="side-item">
						<div class="release-title">还是不知道如何选择产品？没找到合适的产品？</div>
						<el-input class="input-key" placeholder="请输入您的姓名" size="small" v-model="nickname"></el-input>
						<el-input class="input-key" placeholder="请输入您的手机号" size="small" v-model="mobile"></el-input>
						<el-button class="release-btn" type="warning" size="medium">提交</el-button>
					</div>
					<div class="side-item">
						<div class="title">同类产品推荐 <span class="btn" :class="{'change-btn':ischange}" @click="toggleChange" v-if="dataList.length>5"><i class="el-icon-refresh-right"></i>换一换</span></div>
						<div class="user-item" v-for="(item,index) in dataList" :style="{'display':isToggle?index>=5 ?'none':'block':index<5 ?'none':'block'}">
							<div>
								<div class="head-image"><el-image :src="item.logo" fit="scale-down"></el-image></div>
								<div class="user">
									<div class="name">{{item.name}}</div>
									<div class="rate"><el-rate v-model="value" disabled show-score text-color="#ff9900" score-template="{value}"></el-rate></div>
								</div>
							</div>
							<div class="user-desc" style="-webkit-box-orient: vertical;">{{item.baseInfo}}</div>
						</div>	
					</div>
					<div class="side-item">
						<div class="title">公众号</div>
						<el-image class="qrcode" :src="require('@/assets/qrcode.jpg')" fit="contain"></el-image>
						<div class="tips">关注微信公众号，订阅每周资讯</div>
					</div>
					<div class="active-image">
						<el-image :src="require('@/assets/activity-image.png')" fit="contain">
							<div slot="error" class="image-slot">
								<i class="el-icon-picture-outline"></i>
							</div>
						</el-image>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getDetail,getSoftList,softCollect } from '@/api/software/index'
import { toLogin } from '@/api/isLogin'
import { cancleCollect } from '@/api/social/index'
import { getIsTrial, getToken } from '@/utils/auth'
import EventBus from '@/utils/eventHub.js'
export default {
  metaInfo(){
  	return {
  		title: this.data.seoTitle,
  		meta:[{
  			name:'description',
  			content: this.data.seoDescription
  		},{
  			name:'keywords',
  			content: this.data.seoKeyword
  		}]
  	}  
  },
  data () {
    return {
	  value: 4.5,
	  data:{},
	  typeId: '',
	  page:1,
      dataList:[],
	  ischange: false,
	  isToggle: true,
	  nickname:'',
	  mobile:'',
	  softType:{}
    }
  },
  methods: {
   async getData(id){
   	const res = await getDetail(id)
   	if (res.code === 0) {
		res.data.imageList = res.data.images.split(',')
   		this.data = res.data
   	} else {
   	  this.$message.error(res.msg)
   	}
   },
   async cancleSoftCollect(){
   	const res = await cancleCollect({dataId:this.data.id})
   	if (res.code === 0) {
   		 this.$message({
   		  message: '已取消收藏',
   		  type: 'success'
   		});
   		this.getData(this.data.id) 
   	} else {
   	  this.$message.error(res.msg)
   	}
   	
   },
	async getDataList(){
		const res = await getSoftList({page:1,limit:10,isSoftware:1,typeId:this.data.typeId,conSub: 0})
		if (res.code === 0) {
			this.dataList = res.data.list
		} else {
		  this.$message.error(res.msg)
		}
	},
	toggleChange(){
		if(this.dataList.length>5){
			this.ischange = true
			this.isToggle = !this.isToggle
			setTimeout(() => {
			  this.ischange = false;
			}, 500); 
		}
	},
	async collect(){
		if(getToken()){
			const res = await softCollect({dataId:this.data.id,type:'1'})
			if (res.code === 0) {
				this.$message.success('收藏成功')
				this.getData(this.data.id)
			} else {
			  this.$message.error(res.msg)
			}
		}else{
			toLogin(this)
		}
		
	},
  },
  mounted () {
	this.softType = JSON.parse(localStorage.getItem('softType'))
	this.data.id = this.$route.params.id
	this.getData(this.data.id)  
	this.getDataList()
  }

}
</script>

<style lang="scss" scoped>
.container{
	background-color: #e7e7e7;
	margin-top: 80px;
	
	.wrapper{
		max-width: 1400px;
		width: 80vw;
		margin: 0 auto;
		/deep/.el-breadcrumb{
			font-size: 16px;
			margin: 30px 0;
			padding-top: 30px;
		}
		/deep/.el-breadcrumb__inner a,
		/deep/.el-breadcrumb__inner.is-link{
			font-weight: 500;
		}
		/deep/.el-breadcrumb__inner a:hover, 
		/deep/.el-breadcrumb__inner.is-link:hover{
			color: #FF842E;
		}
		.soft-msg{
			background-color: #fff;
			border-radius: 8px;
			padding: 30px;
			&>div{
				display: inline-block;
				vertical-align: top;
			}
			.desc{
				color: #45494F;
				font-size: 16px;
				span{
					margin-right: 40px;
				}
			}
			.logo{
				.el-image{
					width: 80px;
					height: 80px;
					border-radius: 8px;
				}
				margin-right: 20px;
			}
			.name{
				font-size: 18px;
				font-weight: 800;
				color: #3A404E;
			}
			.rate{
				margin: 10px 0;
			}
			.btn{
				float: right;
				.guanzhu-btn{
					margin-right: 20px;
					font-size: 16px;
					display: inline-block;
					vertical-align: middle;
					cursor: pointer;
					.iconfont{
						margin-right: 5px;
						font-size: 18px;
					}
					.icon-31guanzhu1xuanzhong{
						color: #FF440E;
					}
				}
				
				.el-button--warning{
					background-color: #FF842E;
				}
			}
		}
	}
	/deep/.el-input.is-active .el-input__inner,
	/deep/.el-input__inner:focus,
	/deep/.el-textarea__inner:focus{
		border-color: #C0C4CC;
	}
	.soft-wrapper{
		margin-top: 15px;
		display: inline-block;
		width: calc(100% - 300px);
	}
	.sidebar{
		display: inline-block;
		vertical-align: top;
		margin-top: 15px;
		.active-image{
			.el-image{
				width: 270px;
				margin: 0 0 30px 30px;
				
			}
		}
		.side-item{
			width: 270px;
			box-sizing: border-box;
			padding: 24px;
			margin: 0 0 30px 30px;
			border-radius: 15px;
			box-shadow: 0 0 15px rgba(0,0,0, .05);
			background-color: #fff;
			.release-title{
				font-size: 18px;
				font-weight: 800;
				text-align: center;
				margin-bottom: 10px;
			}
			.el-input{
				margin-top: 10px;
				/deep/.el-input__inner{
					border-radius: 20px;
					padding-left: 25px;
				}
				
			}
			.release-btn{
				background-color: #FF842E;
				width: 100%;
				border-radius: 20px;
				margin-top: 20px;
			}
			
			.title{
				font-size: 18px;
				font-weight: 800;
				color: #2B2B2B;
				margin-bottom: 15px;
			}
			.qrcode{
				margin: 20px auto;
				width: 80%;
				display: block;
			}
			.tips{
				font-size: 14px;
				color: #525254;
				text-align: center;
			}
			.user-item{
				margin-top: 15px;
				background-color: #FAFAFA;
				padding: 10px;
				border-radius: 5px;
			}
			.head-image{
				display: inline-block;
				margin-right: 10px;
				.el-image{
					width: 50px;
					height: 50px;
					border-radius: 5px;
				}
			}
			.user{
				display: inline-block;
				vertical-align: top;
				width: calc(100% - 60px);
				.name{
					font-size: 18px;
					font-weight: 800;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					-webkit-box-orient: vertical;
					text-overflow: ellipsis;
					white-space: normal;
				}
				.company{
					color: #4B5D73;
					font-size: 14px;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 1;
					-webkit-box-orient: vertical;
					text-overflow: ellipsis;
					white-space: normal;
				}
			}
			.user-desc{
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				white-space: normal;
				font-size: 14px;
				span:last-child{
					color: #4B5D73;
				}
			}
			.btn{
				cursor: pointer;
				float: right;
				color: #AAAEB4;
				font-weight: 500;
				font-size: 14px;
				.el-icon-refresh-right{
					font-size: 20px;
					margin-right: 5px;
					vertical-align: bottom;
				}
			}
			.change-btn{
				.el-icon-refresh-right{
					transform:rotate(360deg);
					transition: all .5s;
				}
			}
		}
	}
}

</style>